export default "__VITE_ASSET__9dc12826__"